export const customPalette = {
  primary: "#008000",
  secondary: "#ccffcc",
  secondaryHover: "#ccffcccc",
  warning: "#F66B0E",
  error: "#ff531a",
  default: "#fff",
  black: "#000",
  white: "#fff",
  hover: "#00cc00",
};

export const fontSize = {
  large: "x-large",
  medium: "medium",
  small: "small",
};

export const randomA = [
  "แมวส้มสายบวก",
  "แพนด้าล่าแต้ม",
  "นกฮูกดวงดี",
  "จระเข้ขี้เล่น",
  "หมูน้อยนำโชค",
  "กระรอกเทอร์โบ",
  "เสือโคร่งใจดี",
  "หมีขั้วโลกหลงทาง",
  "เป็ดน้อยขี้สงสัย",
  "สลอธผู้รวดเร็ว",
  "นกเพนกวินมาเฟีย",
  "จิ้งจอกเจ้าเล่ห์",
  "กบจอมโดด",
  "เต่าคะนองศึก",
  "ยีราฟคอยาว",
  "ช้างน้อยยอดนักสู้",
  "ลิงจอมซน",
  "แกะสายเมา",
  "ม้าพยศดวงเฮง",
  "สิงโตเจ้าป่า",
];

export const randomB = [
  "#f44336",
  "#e91e63",
  "#9c27b0",
  "#673ab7",
  "#3f51b5",
  "#2196f3",
  "#03a9f4",
  "#00bcd4",
  "#009688",
  "#4caf50",
  "#8bc34a",
  "#cddc39",
  "#ffeb3b",
  "#ffc107",
  "#ff9800",
  "#ff5722",
  "#795548",
  "#9e9e9e",
  "#607d8b",
  "#000000",
];
